import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import AccreditationRequired from '../../AccreditationRequired';

const AccreditationFirst = (props) => {
  const { user } = props;
  const { isAccredited, accreditationType } = user || {};
  const history = useHistory();

  useEffect(() => {
    if (isAccredited && accreditationType === 'third-party-accreditation') {
      history.push('/verify-profile');
    } else if (isAccredited) {
      history.push('/home');
    }
  }, [isAccredited]);

  return (
    isAccredited && accreditationType === 'third-party-accreditation'
      ? null
      : <AccreditationRequired />);
};

AccreditationFirst.propTypes = {
  user: PropTypes.objectOf(PropTypes.any),
};

AccreditationFirst.defaultProps = {
  user: null,
};

const mapStateToProps = ({ auth }) => ({
  user: auth.user,
});

export default connect(mapStateToProps, null)(AccreditationFirst);
